<template>
  <div class="scroll">    
  <v-container fluid fill-height class="pa-0 ma-0 white" id="profile">
    <v-layout column class="pa-0 ma-0">
      <v-card class="elevation-0">
        <v-img height="300" :src="coverUrl ? coverUrl: getCover()">
          <v-layout column align-center justify-center >
            <v-progress-circular
              v-if="loading"
              :size="200"
              :width="15"
              color="info"
              indeterminate
              class="mt-4"
            ></v-progress-circular>            
            <v-avatar v-if="!loading" size="200" class="mt-4" :color="randomColor()">              
              <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked" />                
              <v-tooltip bottom  style="position:absolute; top:0px; right:0px">
                <v-btn slot="activator" @click="toggleShow" :loading="loading" fab small indeterminate dark color="info">
                  <v-icon dark>camera_alt</v-icon>
                </v-btn>
                <span>Upload Foto</span>
              </v-tooltip>              
              <img v-if="user && user.avatar" :src="user ? user.avatar:null" >
              <img v-else-if="imageUrl" :src="imageUrl" />     
              <span v-else class="white--text display-4">{{firstLetter(user ? user.username:null)}}</span>  
            </v-avatar>            
            <h1 class="white--text">{{user?user.username:null}}</h1>                        
          </v-layout>                                               
        </v-img>
        
        <v-card-text class="pa-0">          
            <v-layout row wrap class="grey lighten-4 pa-3">               
            <v-flex xs4>              
              <div class="layout column justify-center align-center">
                <v-btn icon outline color="indigo">
                  <v-icon>fa fa-facebook</v-icon>
                </v-btn>
                <h3 class="indigo--text">100+</h3>
              </div>
            </v-flex>
            <v-flex xs4>
              <div class="layout column justify-center align-center">
                <v-btn icon outline color="pink">
                  <v-icon>fa fa-instagram</v-icon>
                </v-btn>
                <h3 class="pink--text">200+</h3>
              </div>              
            </v-flex>
            <v-flex xs4>
              <div class="layout column justify-center align-center">
                <v-btn icon outline color="blue">
                  <v-icon>fa fa-twitter</v-icon>
                </v-btn>
                <h3 class="blue--text">50+</h3>
              </div>              
            </v-flex>
          </v-layout>
          <v-tabs v-model="selectedTab">
            <v-tab ripple href="#tab-1">
              Profile
            </v-tab>                                
            <v-tabs-items v-model="selectedTab">
              <v-tab-item value="tab-1">                
                <v-card flat>                   
                  <v-card-text class="pa-0">                                         
                    <v-list two-line class="pa-0">
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="indigo">face</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>             
                            {{ user? user.fullname:null }}                            
                          </v-list-tile-title>
                          <v-list-tile-sub-title>Fullname</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <router-link fab absolute top right :to="{path:'/profile/form'}">
                            <v-tooltip left >
                              <v-btn fab small slot="activator" dark color="green">
                                  <v-icon dark>edit</v-icon>
                              </v-btn>  
                              <span>Update Data</span>
                            </v-tooltip>  
                          </router-link>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>          
                      <!--<v-tooltip top>-->
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="indigo">work</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>             
                            {{ user? user.roles:null }}                            
                          </v-list-tile-title>
                          <v-list-tile-sub-title>Job Title</v-list-tile-sub-title>
                        </v-list-tile-content>                          
                      </v-list-tile>
                        <!--<span>Click for Assignment</span>
                      </v-tooltip> --> 
                      <v-divider></v-divider>          
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="indigo">phone</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{user? user.phone : null}}</v-list-tile-title>
                          <v-list-tile-sub-title>Mobile</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action v-if="user && user.phone">
                          <a :href="'tel:'+user.phone"><v-icon>chat</v-icon></a>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="indigo">mail</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{user?user.email:null}}</v-list-tile-title>
                          <v-list-tile-sub-title>Personal</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>                      
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="indigo">location_on</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{user?user.address:null}}</v-list-tile-title>
                          <v-list-tile-sub-title>Address</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>                      
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="indigo">language</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{user?user.nik:null}}</v-list-tile-title>
                          <v-list-tile-sub-title>NIK</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile v-if="user && allowRoles(user.roles)">
                        <v-list-tile-action>
                          <v-icon color="indigo">fingerprint</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{token}}
                            <input type="hidden" id="testing-code" :value="token">
                          </v-list-tile-title>
                          <v-list-tile-sub-title>Token</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action class="cursor" @click="refreshCode">
                          <v-progress-circular v-if="codeLoading"
                            :size="22"
                            :width="2"
                            color="purple"
                            indeterminate
                          ></v-progress-circular>
                          <v-icon v-else>refresh</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-action class="cursor" @click="copyCode">
                          <v-icon>fa fa-copy fa-lg</v-icon>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>                      
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="indigo">color_lens</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{user?user.description:null}}</v-list-tile-title>
                          <v-list-tile-sub-title>Description</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>                      
                    </v-list>                    
                  </v-card-text>
                </v-card>                
              </v-tab-item>
              <v-tab-item value="tab-2">
                <v-card flat>
                  <v-card-text>
                  </v-card-text>
                </v-card>
              </v-tab-item> 
              <v-tab-item value="tab-3">
                <v-card flat>
                  <v-card-text>

                  </v-card-text>
                </v-card>
              </v-tab-item> 
            </v-tabs-items>
          </v-tabs>          
        </v-card-text>
      </v-card>         
      <my-upload style="width:100%" field="img"
        @crop-success="cropSuccess"        
          :width="300"
          :height="300"         
          lang-type="en"
          :value.sync="show"
          v-model="show"                
          img-format="png">            
      </my-upload>                
    </v-layout>
  </v-container>    
  </div>  
</template>

<script>
import colors   from 'vuetify/es5/util/colors';
import myUpload from 'vue-image-crop-upload';
import user from '@/apps/frc/models/User';

let model = new user();


export default {
  components: {     
    'my-upload': myUpload    
  },
  data () {
    return {    
      user_id: null,
      origin :{
        username : null,
        email    : null,
        avatar   : null,
      },
      chat: null,
      selectedTab: null,
      loading: false,
      imageName: '',
      imageUrl: '',
      coverUrl: '',
      imageFile: '',
      show: false,            
      imgDataUrl: '', // the datebase64 url of created image
      token:null,
      codeLoading:false,
      
    };
  },  
  asyncComputed: {    
    user(){
      this.loading = true;      
      return model.profile().then(res=>{        
        let result = res.data;
        this.user_id = result.id;
        this.token = result.token;
        this.loading = false;    
        this.imageName = '';
        this.imageFile = '';
        this.imageUrl = '';
        this.coverUrl = '';
        this.getavatar();
        this.getusercover();
        return result;
      });
    },    
    
  },
  methods: {
    firstLetter (name) {
      return name? name.charAt(0): null;
    },
    getRandom(){      
      var randomArray = ['1.jpg','11.jpg', '12.jpg','13.jpg','14.jpg','16.jpg'];
      return _.sample(randomArray);
      //return require('@/assets/img/bg/'+randomElement);
    },
    getCover(){
      var randomArray   = ['1.jpg','11.jpg', '12.jpg','13.jpg','14.jpg','16.jpg'];
      var randomElement = _.sample(randomArray);
      return require('@/assets/img/bg/'+randomElement);
    },
    randomColor(){
      var randomArray   = colors;
      var color = _.sample(randomArray);     
      return color.base === undefined ? 'info':color.base;
    },
    allowRoles(roles){
      let allows = ['sys_admin', 'dpp', 'dpw', 'dpd', 'dpc', 'korsak', 'kostrat'];
      for(var i in allows){
        if(roles.includes(allows[i]))
          return true;
      }      
    },
    onFilePicked (e) {
      const files = e.target.files;
      if(files[0] !== undefined) {
        this.imageName = files[0].name;
        if(this.imageName.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();                
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.imageUrl  = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
          
          
          var FormData = require('form-data');
          let formData = new FormData();
          
          formData.append('content', files[0], files[0].name);
          formData.append('reff_id', this.user_id);
          formData.append('reff_type', 1);        
          
          this.loading = true;
          model.setavatar(formData).then(res=>{
            this.getavatar();            
          });
          
        });
      } else {
        this.imageName = '';
        this.imageFile = '';
        this.imageUrl  = '';
      }
    },
    refreshCode(){
      this.codeLoading = true;
      model.recode({id:this.user_id}).then(res=>{
        this.token = res.data;
        this.codeLoading = false;
      });
    },
    getavatar(){
      model.getavatar({reff_id:this.user_id}).then(res=>{
        if(res.data){
          this.imageUrl = res.data;
          this.loading  = false;
        }
      });
    },
    getusercover(){
      model.getcover({reff_id:this.user_id}).then(res=>{
        if(res.data){
          this.coverUrl = res.data;
          this.loading  = false;
        }
      });
    },
    toggleShow() {
        this.show = !this.show;
    },            
    cropSuccess(imgDataUrl, field){
        //console.log('-------- crop success --------');
        this.imgDataUrl = imgDataUrl;
        
        var block = imgDataUrl.split(";");
        var contentType = block[0].split(":")[1];// In this case "image/gif"
        var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
        var blob = this.b64toBlob(realData, contentType);

        var FormData = require('form-data');
        let formData = new FormData();

        formData.append('content', blob, 'userprofile');
        formData.append('reff_id', this.user_id);
        formData.append('reff_type', 1);        

        this.loading = true;
        model.setavatar(formData).then(res=>{
          this.getavatar();            
        });
    },               
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
    copyCode () {
      let testingCodeToCopy = document.querySelector('#testing-code')
      testingCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
      testingCodeToCopy.select()

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        window.getApp.$emit('showSnackbar', {
            show : true,
            text : 'The code was copied ' + msg,
            color: 'cyan'
        });        
      } catch (err) {
        alert('Oops, unable to copy');
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
  }
};
</script>
<style>
  #profile-scroll{
      height: calc(100vh - 96px);
      overflow-y:auto; 
  }
  .vue-image-crop-upload .vicp-wrap{      
      height: 70%;
      width : 80%;
      min-height:330px;
      max-width: 600px;
  }
</style>